/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import {assert} from 'Asserts';
import {DNAStartCodon} from 'biojs/Codons';
import {Sequence} from 'components/Sequence';
import * as MapsConstants from 'constants/MapsConstants';
import * as mapsutil from 'molbio/maps/MapsUtil';
import * as selectables from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';
import ORF from 'molbio/translations/backbone/ORF';

export type Frame = 'All' | 'Forward' | 'Reverse' | 1 | 2 | 3 | -1 | -2 | -3;

class ORFs extends selectables.Collection<ORF> {
  static initClass(): void {
    this.prototype.model = ORF;
  }

  override initialize(models: Array<ORF>): void {
    super.initialize(models);
    this.setLayers();

    // There are places in the code where we iterate through all the annotations and make changes.
    // These methods only need to be triggered once (and its results get used by views), so we debounce
    // the computations.

    // Debouncing setLayers caused bad state... maybe because layerChange gets called too early?
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return this.listenTo(this, 'add remove reset', this.setLayers);
  }

  sliceAndFilter(
    start: number,
    end: number,
    // TODO: Remove startCodon and rely on its already being filtered by Sequence.updateORFs
    options: {sequence: Sequence; minLength?: number; frame?: Frame; startCodon?: DNAStartCodon}
  ): Array<ORF> {
    let data = this.filter((orf) => {
      const aStart = orf.start();
      const aEnd = orf.end();
      return sequtil.isRangeOverlap(start, end, aStart, aEnd);
    });

    _.sortBy(data, (orf) => {
      const x1 = Math.max(start, orf.start()) - start;
      const x2 = Math.min(end, orf.end()) - start;
      return x1 - x2;
    });

    const {sequence} = options;
    data = data.filter((orf) => {
      assert(orf.startCodon() === options.startCodon, 'Expected ORFs to already be filtered by start codon');
      return orf.startCodon() === options.startCodon;
    });

    if (options.minLength != null) {
      data = data.filter((orf) => orf.length(sequence) >= options.minLength!);
    }
    if (options.frame != null && options.frame !== 'All') {
      if (options.frame === 'Forward' || (typeof options.frame === 'number' && options.frame > 0)) {
        data = data.filter((orf) => orf.strand() === 1);
      } else if (options.frame === 'Reverse' || options.frame < 0) {
        data = data.filter((orf) => orf.strand() === -1);
      }

      if ([1, 2, 3, -1, -2, -3].includes(options.frame as number)) {
        const frame = Math.abs(options.frame as number) - 1;
        data = data.filter((orf) => {
          if (orf.strand() === 1) {
            return orf.start() % 3 === frame;
          } else {
            return orf.end() % 3 === frame;
          }
        });
      }
    }
    return data;
  }

  setLayers(): void {
    const modelsAndLayers = mapsutil.getModelLayers(this.models, {top: true});
    for (const {model, layer} of Array.from(modelsAndLayers)) {
      model.fastSet(MapsConstants.LINEAR_LAYER_FULL, layer);
    }
    this.trigger('layerChange');
  }
}

ORFs.initClass();

export default ORFs;
